import React from 'react'
import { EmptyWrapper } from './styles'

import { usePatient } from '~/context'
import { SpinnerIconLoader } from '~/components/shared'
import { IconComponent } from '~/assets/icons/component'

export function withDashboardLoader<T extends JSX.IntrinsicAttributes>(
  WrappedComponent: React.ComponentType<T>
): (props: T) => JSX.Element {
  const ComponentOrLoader = (props: T): JSX.Element => {
    const { getVisiblePatientId } = usePatient()
    const patientId = getVisiblePatientId()

    if (!patientId) {
      return (
        <EmptyWrapper>
          <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
        </EmptyWrapper>
      )
    }

    return <WrappedComponent {...props} />
  }

  return ComponentOrLoader
}
